import type { RouteRecordRaw } from "vue-router";
import {
  mainRoutes,
  nailSupplyRoutes,
  technicianRoutes,
  postRoutes,
  authRoutes,
  errorRoutes,
  promotionRoutes,
  postSavedRoutes
} from "./routes/index";

// Merge all route modules into a single configuration
const routes: RouteRecordRaw[] = [
  // Main layout with nested routes
  {
    ...mainRoutes,
    children: [
      ...(mainRoutes.children || []),
      ...nailSupplyRoutes,
      ...technicianRoutes,
      ...promotionRoutes
    ]
  },
  // Post routes (requires authentication)
  postRoutes,
  postSavedRoutes,
  // Authentication routes
  authRoutes,
  // Error handling routes
  ...errorRoutes
];

export default routes;
